import 'core-js/stable';
import './iab/uspAPI';

import {initTrackers} from './index';
import {getScriptSettings} from '../common/settings';

const {settings, initConfig, env} = getScriptSettings();
initTrackers({settings, init: initConfig, env}).then(() => console.debug('Trackers init complete'));
